import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#1C1040] pt-2 md:pt-3 pb-5 md:pb-7 px-4" data-id="element-196" data-mp="4uqcgsut9wrq">
      <div className="max-w-3xl mx-auto" data-id="element-197" data-mp="4x345xqdflhz">
        <div className="relative bg-gradient-to-b from-[#1a0a35] to-[#120822] border-2 border-gold rounded-2xl p-3.5 md:p-5 text-center guarantee-glow" data-id="element-198" data-mp="9u38a33nue6g">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-check/15 border-2 border-check/40 flex items-center justify-center mx-auto mb-1.5" data-id="element-199" data-mp="er35rpmg28ly">
            <ShieldCheck className="w-5 h-5 md:w-6 md:h-6 text-check" strokeWidth={2} data-id="element-200" data-mp="nt2pipoufqsl" />
          </div>

          <h2 className="font-display font-bold text-white text-base md:text-2xl mb-1.5 leading-tight" data-id="element-201" data-mp="sn6ux4ignqrk">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-white/85 text-[12px] md:text-sm leading-snug" data-id="element-202" data-mp="12klbr58aqhke">
            Abrís los 6 tomos, revisás los 5 bonos y los usás en tu cocina.
          </p>
          <p className="text-white text-[12px] md:text-sm mt-1 leading-snug" data-id="element-203" data-mp="25sgifflb2a1e">
            Si no es lo que esperabas,{' '}
            <span className="font-display font-black text-gold text-xl md:text-2xl" data-id="element-204" data-mp="20s2ikktuy6eg">
              te devolvemos el 100%.
            </span>
          </p>
          <p className="text-white/70 italic text-[11px] md:text-xs mt-1.5" data-id="element-205" data-mp="1rs5qsac68rf6">
            Sin preguntas. Sin formularios. Sin drama.
          </p>

          <div className="pt-2 mt-2 border-t border-white/10" data-id="element-206" data-mp="2oh3ljsjx8pcc">
            <p className="text-white/70 text-[10px] md:text-xs leading-snug" data-id="element-207" data-mp="2jjlhafgumyao">
              El mismo compromiso para todos, desde México hasta Argentina.
            </p>
          </div>
        </div>
      </div>
    </section>;
}